// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import React from 'react';
import { TableTdElement } from '../body-cell/td-element';
import { ItemsLoader } from './items-loader';
export function TableLoaderCell({ item, trackBy, counter, children, ...props }) {
    return props.isRowHeader ? (React.createElement(TableTdElement, { ...props, counter: counter, isEditable: false, isEditing: false },
        React.createElement(ItemsLoader, { item: item, trackBy: trackBy }, children))) : (React.createElement(TableTdElement, { ...props, isEditable: false, isEditing: false }, null));
}
//# sourceMappingURL=loader-cell.js.map